import { baseAuthApi } from "../../core/service/baseApi";
import { ChangeLogEntryDtoToEntity } from "./mappers/ChangeLogEntryDtoToEntity";
import type { ChangeLogEntryDto } from "./types/ChangeLogEntryDto";
import type { ChangeLogEntryEntity } from "./types/ChangeLogEntryEntity";

interface ChangeLogPageDto {
    list?: ChangeLogEntryDto[];
    currentPage?: number;
    totalPages?: number;
}

const historyApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        entityHistory: builder.query<ChangeLogEntryEntity[], string>({
            query: (url) => ({
                url,
                method: "GET",
            }),
            transformResponse: (response: ChangeLogPageDto) => (response.list ?? []).map(ChangeLogEntryDtoToEntity),
        }),
    }),
});

export const { useLazyEntityHistoryQuery } = historyApi;
